import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import FAQSection from './components/FAQSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AppSection />
        <AboutSection />
        <CommentsSection />
        <RankingSection />
        <IndexSection />
        <FeaturesSection />
        <MediaSection />
        <CarouselSection />
        <ContactSection />
        <FAQSection />
        <CardsSection />
        <UpdatesSection />
        <TopicsSection />
      </main>
      <Footer />
    </>
  );
}